export default __webpack_public_path__ + "static/media/red-bar.0fcd0ede.png";